<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper">
	<div class="m-content">
		<!--begin::Portlet-->
		<!--begin::Form-->
		<form
			[formGroup]="operatorForm"
			*ngIf="operatorForm"
			class="m-form m-form--fit m-form--label-align-right">

				<div class="m-portlet">

					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text" *ngIf="!cue5050Id">
									STATION OPERATOR INFORMATION
								</h3>
								<span (click)="openOperatorInfo()" class="info-header-icon m-portlet__head-text">
									<img
										src="../../assets/app/media/img/icons/info-icon.png"
										class="tooltip-icon"
										style="position: relative; cursor: pointer;"
										tooltip="Click here for more information about Station Operators"
										/>
								</span>
							</div>
						</div>
					</div>



					<div class="m-portlet__body">
						<div class="m-form__section m-form__section--first">

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Operator Full Name:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="name"
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="operatorFC('name')"
								errorMessage="Please provide this operator's name"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Contact Email:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="email"
								[ignoreWhiteSpace]
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="operatorFC('email')"
								errorMessage="Please provide a valid operator email address"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Contact Phone Number:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="phoneNumber"
								[ignoreWhiteSpace]
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="operatorFC('phoneNumber')"
								errorMessage="Please provide a valid operator phone number"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Expiration Date:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="expires"
								class="form-control m-input"
								angular-mydatepicker
								#expiresPicker="angular-mydatepicker"
								(keydown)="$event.preventDefault();"
								(click)="expiresPicker.toggleCalendar()"
                (dateChanged)="guestChange()"
								[options]="expiresDateOptions"
								[ngValue]="operatorFC('expires').value"
							/>
							<app-validation-display
								[control]="operatorFC('expires')"
								errorMessage="Please provide a valid expiration date"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Guest Account:
						</label>
						<div style="padding-top: 7px;" class="col-lg-3">
							<label class="switch">
								<input
									(change)="guestChange()"
									formControlName="guest"
									type="checkbox"
									/>

								<span class="slider round"></span>
								</label>
						</div>
					</div>

					<div class="form-group m-form__group row" [hidden]="!operatorFC('guest').value">
						<label class="col-lg-4 col-form-label">
						Guest Login Username:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="username"
								[ignoreWhiteSpace]
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="operatorFC('username')"
								errorMessage="Please provide a valid guest operator username"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row" [hidden]="!operatorFC('guest').value">
						<label class="col-lg-4 col-form-label">
						{{ operatorId > 0 ? "New" : "" }} Guest Password:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="guestPassword"
								[ignoreWhiteSpace]
								type="password"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="operatorFC('guestPassword')"
								errorMessage="Please provide a valid guest operator password"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row" [hidden]="!operatorFC('guest').value">
						<label class="col-lg-4 col-form-label">
						Confirm Password:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="guestPassword2"
								[ignoreWhiteSpace]
								type="password"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<div
								class="help"
								style="margin-bottom: 10px; color: red;"
								*ngIf="operatorFC('guestPassword2').touched
									&& operatorFC('guestPassword').value != operatorFC('guestPassword2').value" >
								<span>
								<span>Passwords must match</span>
								</span>
							</div>
						</div>
					</div>

					</div>
				</div>

			</div>

			<app-location-form
					*ngIf="operatorForm"
					[hidden]="!operatorFC('guest').value"
					formName="OPERATOR LOCATION"
					[disableForm]="true"
					[disableSelection]="false"
					[parentGroup]="operatorForm"
					[locationData]="operator?.location">
			</app-location-form>
        </form>

        <div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button type="submit" (click)="save()" class="btn btn-primary">
				{{ operatorId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				Cancel
				</button>
				<div *ngIf="hasLocationErrors() && this.operatorForm.controls.location.touched">
					<span style="color:red">Please assign or create a location for this station operator</span>
				</div>
				<div *ngIf="hasOperatorErrors() && this.operatorForm.touched">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>
    </div>
</div>
